import { Component } from '@angular/core';
import { SkyModalInstance } from '../modal';
import { SkyColumnSelectorContext } from './column-selector-context';


export class SkyColumnSelectorComponent {
  public newSelectedColumnIds: Array<string> = [];

  constructor(
    public context: SkyColumnSelectorContext,
    public instance: SkyModalInstance
  ) {
    this.newSelectedColumnIds = context.selectedColumnIds;
  }

  public selectedColumnsChange(selectedMap: Map<string, boolean>) {
    this.newSelectedColumnIds = [];
    selectedMap.forEach((value, key) => {
      if (value) {
        this.newSelectedColumnIds.push(key);
      }
    });
  }

  public cancelChanges() {
    this.instance.cancel();
  }

  public applyChanges() {
    this.instance.save(this.newSelectedColumnIds);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-column-selector',
  template: `<sky-modal>
  <sky-modal-header>
    {{'grid_column_picker_header' | skyResources}}
  </sky-modal-header>
  <sky-modal-content>
    <sky-list #list
      [data]="context.columns"
      [selectedIds]="context.selectedColumnIds"
      (selectedIdsChange)="selectedColumnsChange($event)">
      <sky-list-toolbar
        [placeholder]="'grid_column_picker_search_placeholder' | skyResources">
      </sky-list-toolbar>

      <sky-list-view-checklist label="heading" description="description">
      </sky-list-view-checklist>
    </sky-list>
  </sky-modal-content>
  <sky-modal-footer>
    <button
      sky-cmp-id="apply-changes"
      class="sky-btn sky-btn-primary"
      (click)="applyChanges()">
      {{'grid_column_picker_submit' | skyResources}}
    </button>
    <button
      sky-cmp-id="cancel"
      class="sky-btn sky-btn-link"
      (click)="cancelChanges()">
      {{'grid_column_picker_cancel' | skyResources}}
    </button>
  </sky-modal-footer>
</sky-modal>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyColumnSelectorContext, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
